import React from "react";

import { ToneSegments } from "../../../../components/FormPanel";
import { SEGMENT_LABELS, TONE_BY_TYPE } from "./constants";
import { TypeSegmentsProps } from "./types";

export const TypeSegments: React.FC<TypeSegmentsProps> = (props) => (
  <ToneSegments
    groupLabel="Type"
    toneByValue={TONE_BY_TYPE}
    labelByValue={SEGMENT_LABELS}
    {...props}
  />
);
